import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import { ArrowLeft2 } from 'iconsax-react';
import { useTranslation } from 'react-i18next';
import useNavigationMenuStyles from './useNavigationMenuStyles';
import DesktopIcon from '@ui/assets/custom-icons/desktop-icon';
import MobileIcon from '@ui/assets/custom-icons/mobile-icon';
import TabletIcon from '@ui/assets/custom-icons/tablet-icon';
import { useNavigate, useParams } from 'react-router-dom';
const BackButton = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { e } = useParams();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const handleGoBack = () => {
        navigate(`/create-event?eventId=${e}`);
    };
    return (_jsx(Button, { variant: 'outlined', size: isSmallScreen ? 'small' : isMediumScreen ? 'medium' : 'large', color: 'primary', startIcon: _jsx(ArrowLeft2, { size: 18 }), onClick: handleGoBack, children: t('actions.back') }));
};
const LayoutTabs = ({ activeLayout, setActiveLayout }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const styles = useNavigationMenuStyles();
    const layouts = [
        {
            id: 'desktop',
            label: t('events.preview.desktop'),
            value: 'desktop',
            Icon: DesktopIcon
        },
        {
            id: 'tablet',
            label: t('events.preview.tablet'),
            value: 'tablet',
            Icon: TabletIcon
        },
        {
            id: 'mobile',
            label: t('events.preview.mobile'),
            value: 'mobile',
            Icon: MobileIcon
        }
    ];
    return (_jsx(Box, { className: 'layout-tabs', sx: {
            ...styles.layoutTabsContainer,
            p: isSmallScreen ? '6px' : isMediumScreen ? '10px' : '12px'
        }, children: layouts.map((layout) => {
            return (_jsx(Button, { variant: activeLayout === layout.value ? 'contained' : 'outlined', size: isSmallScreen ? 'small' : isMediumScreen ? 'medium' : 'large', color: layout.value === activeLayout ? 'primary' : 'inherit', startIcon: _jsx(layout.Icon, {}), onClick: () => setActiveLayout(layout.value), sx: {
                    flex: '0 0 auto',
                    '.desktop-icon, .tablet-icon': {
                        path: {
                            stroke: activeLayout === layout.value
                                ? theme.palette.common.white
                                : theme.palette.common.black
                        }
                    },
                    '.mobile-icon': {
                        path: {
                            fill: activeLayout === layout.value
                                ? theme.palette.common.white
                                : theme.palette.common.black
                        }
                    }
                }, children: layout.label }, layout.id));
        }) }));
};
const NavigationMenu = ({ activeLayout, setActiveLayout }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const styles = useNavigationMenuStyles();
    return (_jsxs(Box, { sx: styles.container, children: [_jsx(Box, { className: 'back-button-container', sx: {
                    ...styles.backButtonContainer,
                    p: isSmallScreen ? '6px' : isMediumScreen ? '10px' : '12px'
                }, children: _jsx(BackButton, {}) }), _jsx(LayoutTabs, { activeLayout: activeLayout, setActiveLayout: setActiveLayout })] }));
};
export default NavigationMenu;
